import React, {Fragment} from 'react';
import { Modal } from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
import Button from '../button/Button';
import Filter from '../filter/Filter';

class ModalFilter extends AbstractComponent { 
    constructor(props) {
        super(props);

        this.state = {
            filter: [],

            preload: false
        }          
        
        this.state.filter = this.props.filter;
    }  
    
    onFilterClearClick() {
        var filter = this.state.filter;
        let filterClean = [];

        filter.forEach(element => {
            element.valor = '';
        
            filterClean.push(element);
        });
        
        this.setState({filter: filterClean});

        this.foco(this.props.defaultFocoFilter);
    }        
    
    onFilterChange(index, e) {        
        var filter = this.state.filter;

        filter[index].valor = e.target.value;        

        this.setState({filter: filter});
    }  

    onFilterChangeSelect(index, e) {
        var filter = this.state.filter;

        filter[index].valor = e.target.value;        

        this.setState({filter: filter});                
    }  

    onAplicarClick() {
        this.setState({preload: true});

        this.props.filterService(
            this.state.filter,
            1
        ).then(resposta => {
            this.props.onCallback(this.state.filter, resposta, undefined);
            this.setState({preload: false});            
        }).catch(erro => {
            this.props.onCallback(this.state.filter, undefined, erro);
            this.setState({preload: false});
        });
    }

    show() {
        if(!this.props.show)
            return ;

        return (
            <Modal
                className={this.props.fullscreen ? "modal-fullscreen" : "modal"}
                show={this.props.show}
                onHide={() => this.props.fechar()}>

                <Modal.Header closeButton>
                    <Modal.Title>
                        &nbsp; 
                        &nbsp; 
                        
                        Filtros                       
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Filter
                        filter={this.state.filter}
                        showButtonSearch={false}
                        preload={this.state.preload}
                        defaultFoco={this.props.defaultFocoFilter}

                        onFilterChange={(index, e) => this.onFilterChange(index, e)}
                        onFilterChangeSelect={(index, e) => this.onFilterChangeSelect(index, e)}
                        onFilterButtonClick={() => this.onFilterButtonClick(this.state.filter)}
                        onFilterClearClick={() => this.onFilterClearClick()}

                        onClose={() => this.props.fechar()}
                    /> 
                </Modal.Body> 

                <Modal.Footer>                    
                    <Button                         
                        className={"btn btn-primary " + (this.state.preload ? "is" : "not") + "-loading has-text text-center"}
                        type="button"     
                        disabled={this.state.preload}                            
                        onClick={() => {this.onAplicarClick()}}
                    >
                        <div className="btn-spinner">
                            <div className="double-bounce1">
                            </div>
                            
                            <div className="double-bounce2">
                            </div>

                            {
                                this.state.preload &&
                                'Aguarde...'
                            }   
                        </div>

                        <i className="fa fa-search"/>                                             
                        
                        {
                            !this.state.preload &&
                            <Fragment>
                                &nbsp; Aplicar
                            </Fragment>
                        }
                    </Button>

                    <Button 
                        className="btn btn-light"
                        type="button"   
                        style={{width: '110px'}}                              
                        onClick={() => {this.props.fechar()}}
                    >
                        <i className="fas fa-arrow-down"></i> &nbsp; Fechar
                    </Button>
                </Modal.Footer>                                         
            </Modal>                     
        )
    }    

    render() {
        return (
            <Fragment>
                {this.show()}            
            </Fragment>
        )
    }
}

ModalFilter.defaultProps = {    
    styleText: '',
    fullscreen: false
}

export default ModalFilter;